import { MenuTargetContract } from "./menu-target.contract";

export interface MenuContract {
  links: MenuTargetContract[],
  target: MenuTargetContract
}